import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router";
import Api from "../../services/Api";
import CustomButton from "../../components/CustomButton";
import BadgeCheckIcon from "../../components/Icons/BadgeCheckIcon";
import EmailIcon from "../../components/Icons/EmailIcon";

const Unsubscribe = () => {
  const api = Api.getInstance();
  const navigate = useNavigate();
  const [unsubscribe, setUnsubscribe] = useState<boolean>(false);
  const [justSubscribed, setJustSubscribed] = useState<boolean>(false);
  const [loaded, setLoaded] = useState<boolean>(false);

  useEffect(() => {
    api.get("client/unsubscribe").then((response) => {
      setUnsubscribe(response.json.unsubscribe);
      setLoaded(true);
    });
  }, []);

  const updateUnSubscribe = (unsubscribeAction: boolean) => {
    const data = {
      unsubscribeAction: unsubscribeAction,
    };
    api.post("client/unsubscribe", data).then((response) => {
      if (response.json.unsubscribe === false) {
        setJustSubscribed(true);
      }
      setUnsubscribe(response.json.unsubscribe);
    });
  };

  if (!loaded) {
    return <div className="mt-4 main-content">Loading...</div>;
  }

  if (justSubscribed) {
    return (
      <div className="main-content text-center mt-10">
          <EmailIcon alt="check" className="w-12 h-12 mx-auto"/>
          <h1 className="z-heading1 text-white">
              Unsubscribe
          </h1>
          <p className="mt-2 text-gray-400">
              By unsubscribing, you’ll no longer receive any tips, reminders, or news from us –
              just the essential account-related messages
          </p>
          <p className="mt-4 text-gray-400">
              You can always re-subscribe to stay in the loop!
          </p>
          <CustomButton className="mt-6" buttonType="blueBase" onClick={() => navigate('/')}>
              I'd rather stay
          </CustomButton>
          <CustomButton className="mt-2" buttonType="outlineWhiteBase" onClick={() => updateUnSubscribe(true)}>
              Unsubscribe
          </CustomButton>
      </div>
    );
  } else if (unsubscribe) {
    return (
      <div className="main-content text-center mt-10">
        <BadgeCheckIcon aria-label="check" className="w-12 h-12 mx-auto text-success-500!" />
        <h1 className="z-heading1 text-white">
          You have unsubscribed!
        </h1>
        <p className="mt-2 text-gray-400">
          You’ll no longer receive any emails from us, except for essential
          account-related messages.
        </p>
        <p className="mt-4 text-gray-400">
          You can always re-subscribe to stay in the loop!
        </p>
        <CustomButton
          className="mt-6"
          buttonType="blueBase"
          onClick={() => updateUnSubscribe(false)}
        >
          Re-subscribe
        </CustomButton>
      </div>
    );
  }

  return (
    <div className="main-content text-center mt-10">
      <EmailIcon alt="check" className="w-12 h-12 mx-auto" />
      <h1 className="z-heading1 text-white">Unsubscribe</h1>
      <p className="mt-2 text-gray-400">
        By unsubscribing, you’ll no longer receive any tips, reminders, or news
        from us – just the essential account-related messages
      </p>
      <p className="mt-4 text-gray-400">
        You can always re-subscribe to stay in the loop!
      </p>
      <CustomButton
        className="mt-6"
        buttonType="blueBase"
        onClick={() => navigate("/")}
      >
        I'd rather stay
      </CustomButton>
      <CustomButton
        className="mt-2"
        buttonType="outlineWhiteBase"
        onClick={() => updateUnSubscribe(true)}
      >
        Unsubscribe
      </CustomButton>
    </div>
  );
};

export default Unsubscribe;
